var map = {
	"./controls": 10,
	"./controls.coffee": 10,
	"./feedback": 11,
	"./feedback.coffee": 11,
	"./import": 22,
	"./import.coffee": 22,
	"./import_google": 23,
	"./import_google.coffee": 23,
	"./index": 12,
	"./index.coffee": 12,
	"./preset": 24,
	"./preset.coffee": 24,
	"./setup": 25,
	"./setup.coffee": 25,
	"./welcome": 26,
	"./welcome.coffee": 26
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;



/*****************
 ** WEBPACK FOOTER
 ** ./app/views/register ^\.\/.*$
 ** module id = 54
 ** module chunks = 0
 **/